/**
 * Standard node library — generic nodes shipped with @engine/redprint.
 * These have no engine-specific dependencies.
 */
import { createBootstrap } from '@engine/graph';
import type { NodeBehaviour } from '../types';
import { getDefaultRegistry } from '../node/NodeRegistry';

export { MATH_NODES } from './math';
export { LOGIC_NODES } from './logic';
export { FLOW_NODES } from './flow';
export { DEBUG_NODES } from './debug';
export { VFX_NODES } from './vfx';

import { MATH_NODES } from './math';
import { LOGIC_NODES } from './logic';
import { FLOW_NODES } from './flow';
import { DEBUG_NODES } from './debug';
import { VFX_NODES } from './vfx';

/** All standard (engine-agnostic) nodes bundled with redprint. */
export const STANDARD_NODES: readonly NodeBehaviour[] = [
  ...MATH_NODES,
  ...LOGIC_NODES,
  ...FLOW_NODES,
  ...DEBUG_NODES,
  ...VFX_NODES,
];

/**
 * Register the standard node library into the default registry. Idempotent
 * (shared {@link createBootstrap} guard) — mirrors `registerBuiltinVFXNodes`
 * so both graph systems share one registration entry-point shape.
 */
export const registerBuiltinRedprintNodes = createBootstrap(() => {
  getDefaultRegistry().registerAll(STANDARD_NODES);
});
